import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { TranslatePipe } from "@ngx-translate/core";
import { FormxInputComponent } from "@shared/component/formx-input/formx-input.component";
import { DialogHeaderComponent } from "@shared/dialogs/dialog-header/dialog-header.component";
import { DealerInfoDTO } from "@shared/model/dealer.model";
import { DealerService } from "@shared/services/dealers/dealer.service";
import { UsersService } from "@shared/services/users/users.service";
import { VehicleService } from "@shared/services/vehicle/vehicle.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";
import {take} from "rxjs/operators";
import {switchMap} from "rxjs";

@Component({
	selector: 'app-booklet-dialog',
	imports: [
		ReactiveFormsModule,
		SharedModule,
		TranslatePipe,
		DialogHeaderComponent,
		MatDialogContent,
		FormxInputComponent
	],
	templateUrl: './booklet-dialog.component.html',
	styleUrl: './booklet-dialog.component.scss',
})
export class BookletDialogComponent implements OnInit {
	bookletForm: UntypedFormGroup = new UntypedFormGroup({
		licensePlate: new UntypedFormControl("", Validators.required),
		vatCode: new UntypedFormControl("", Validators.required)
	});

	dealer: DealerInfoDTO;
	isAdmin: boolean;

	constructor(
		public wcmService: WcmService,
		private dealerService: DealerService,
		private vehicleService: VehicleService,
		private userService: UsersService,
		private dialogRef: MatDialogRef<BookletDialogComponent>,
	) { }

    ngOnInit() {
        this.userService.getProfileOfLoggedUser()
            .pipe(
                take(1),
                switchMap(user => this.dealerService.getDealerInfoUsingGET(user.idDealer))
            )
            .subscribe(dealer => {
                this.dealer = dealer;
                this.bookletForm.get("vatCode")?.setValue(dealer.vatCode);
            });

        this.userService.isAdmin().subscribe(value => {
            this.isAdmin = value;
        });
    }

    onConfirm() {
        if (this.bookletForm.valid) {
            this.vehicleService
                .getDossierUrlUsingGET(
                    this.bookletForm.get('licensePlate')?.value,
                    this.bookletForm.get('vatCode')?.value
                )
                .subscribe(value => {
                    if (value?.url) {
                        window.open(value.url, '_blank');
                        this.dialogRef.close();
                    }
                });
        }
    }

	close() {
		this.dialogRef.close();
	}
}
